import {useIntl} from 'react-intl';
import React, {useCallback} from 'react';
import Cancel from '@material-ui/icons/Cancel';

import './CloseButton.scss';

interface CloseButtonProps {
  className?: string;
  disabled?: boolean;
  onBlur?: () => void;
  onHover?: () => void;
  onRemove: () => void;
}

const CloseButton = ({
  className = '',
  disabled = false,

  onRemove,
}: CloseButtonProps) => {
  const intl = useIntl();

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
      onRemove();
    },
    [onRemove]
  );

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={handleClick}
      className={`segment-control-close-button ${className}`}
      aria-label={intl.formatMessage({
        id: 'segmentedCreator.segmentControl.remove',
      })}
    >
      <Cancel fontSize="small" />
    </button>
  );
};

export default CloseButton;
